import { User } from "../../utils/types/user";
import {
  GetUsersAction,
  SetUserAction,
  SetUserLogoutAction,
} from "../action/userAction";

interface UserState {
  user: User | null;
}

interface UsersState {
  users: User[];
}

const initialState: UserState = {
  user: null,
};

const initialUsersState: UsersState = {
  users: [],
};

export const userReducer = (
  state = initialState,
  action:
    | SetUserAction
    | SetUserLogoutAction
    | GetUsersAction
    | { type: string; payload: any }
): UserState => {
  switch (action.type) {
    case "SET_USER":
      return { ...state, user: action.payload };
    case "Log_Out":
      return { ...state, user: action.payload };
    default:
      return state;
  }
};

export const usersReducer = (
  state = initialUsersState,
  action: GetUsersAction
): UsersState => {
  switch (action.type) {
    case "GET_USERS_SUCCESS":
      return { ...state, users: action.payload };
    case "GET_USERS_ERROR":
      return { ...state, users: action.payload };
    default:
      return state;
  }
};
